module.exports = __webpack_public_path__ + "img/wf-finishing-position-15.a7c7c0da.svg";